module.exports = __webpack_public_path__ + "img/logo_etat_fribourg.488cef24.svg";